import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      attrs: { "offset-y": "", left: "", transition: "slide-y-transition" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBtn,
                _vm._g({ attrs: { icon: "" } }, on),
                [_c(VIcon, [_vm._v("mdi-view-grid-outline")])],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VCard,
        {
          staticClass: "d-flex flex-row flex-wrap",
          staticStyle: { "max-width": "280px" },
        },
        _vm._l(_vm.apps, function (app) {
          return _c(
            "div",
            {
              key: app.link,
              staticClass: "app-tile pa-3 text-center",
              staticStyle: { flex: "0 50%" },
              on: {
                click: function ($event) {
                  return _vm.navigateTo(app.link)
                },
              },
            },
            [
              _c(VIcon, { attrs: { color: "primary" } }, [
                _vm._v(_vm._s(app.icon)),
              ]),
              _c("div", { staticClass: "font-weight-bold mt-1" }, [
                _vm._v(_vm._s(app.key ? _vm.$t(app.key) : app.text)),
              ]),
              _c("div", { staticClass: "caption" }, [
                _vm._v(
                  _vm._s(
                    app.subtitleKey ? _vm.$t(app.subtitleKey) : app.subtitle
                  )
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }